import axios from "axios";

export const http = axios.create({
  baseURL: "/",
  withCredentials: false,
});

http.interceptors.response.use(
  (r) => r,
  async (error) => {
    return Promise.reject(error);
  }
);

